import React, { useEffect, useRef, useState } from 'react';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import Uploadbg from '../../assets/images/backgrounds/bg-file-upload.png'

const FileUploadModal = ({ show, onClose, onUpload, loading }) => {
    const hiddenFileInput = useRef(null);

    const [sel_file, set_sel_file] = useState(null)
    const [current_file, set_current_file] = useState(null)

    const onSelectFile = event => {
        const fileUploaded = event.target.files[0];
        set_current_file(URL.createObjectURL(event.target.files[0]));
        set_sel_file(fileUploaded)
    };

    const onPickClick = event => {
        hiddenFileInput.current.click();
    };

    const onSubmit = () => {
        if (sel_file)
            onUpload(sel_file)
    }

    useEffect(()=>{
        if(!show){
            set_sel_file(null)
            set_current_file(null)
        }
    },[show])

    return (
        <Dialog
            sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 500 } }}
            maxWidth="xs"
            open={show}
        >
            <DialogTitle py={3}>
                <Typography variant='h4' sx={{ color: (theme) => theme.palette.error.main }}>Upload</Typography>
            </DialogTitle>

            <DialogContent dividers>
                <Alert variant="outlined" severity="info">Cliquez sur l'image pour en choisir une.</Alert>
                <Box textAlign='center' py={1}>
                    <img onClick={onPickClick} src={current_file ? current_file : Uploadbg} alt="nm" style={{ width: 200, borderRadius: 3, cursor: 'pointer' }} />
                    <br />
                    {sel_file &&
                        <Button onClick={onSubmit} variant='contained' color='success' sx={{ my: 1 }} disabled={loading}>Upload</Button>
                    }
                </Box>
                <input type="file" onChange={onSelectFile} ref={hiddenFileInput} style={{ display: 'none' }} accept="image/*" />
            </DialogContent>

            <DialogActions>
                <Button autoFocus onClick={onClose}>
                    Annuler
                </Button>
            </DialogActions>

        </Dialog>
    );
};

export default FileUploadModal;